import { useState, useCallback } from 'react';
import { apiClient, withErrorHandling } from '../utils/apiErrorHandling';

const useCategorySearch = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const searchCategories = useCallback(async (site, name) => {
        setLoading(true);
        setError(null);
        
        const result = await withErrorHandling(
        () => apiClient.post('/categories/search', { site, name }),
        {
            onError: (apiError, message) => {
            setError(message);
            }
        }
        );
        
        setLoading(false);
        
        if (result.success) {
        setCategories(result.data.data || []);
        return result.data.data || [];
        } else {
        setCategories([]);
        return [];
        }
    }, []);

    const clearResults = useCallback(() => {
        setCategories([]);
        setError(null);
    }, []);

    return {
        categories,
        loading,
        error,
        searchCategories,
        clearResults
    };
};

export default useCategorySearch;
